import type { RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

export const notificationsRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () =>
      import('./notification-list/NotificationListTab').then((m) => ({
        Component: m.NotificationListTab,
      })),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute
        routePath="/notifications"
        linkText="Go back to notifications"
      />
    ),
  },
];
